export default __webpack_public_path__ + "de3c4c1067e1cfac90a0b91860381ad6.png";